import getDirectHybrisAxiosClient from '../clients/directHybrisAxiosClient';
import type { HybrisResolveRecipesRequest } from './requests/directRecipeEcommerceApiRequests';
import type {
    HybrisRecipeList,
    HybrisSubstituteResponse,
} from './responses/directRecipeEcommerceApiResponses';

const resolveRecipes =
    (token?: string) =>
    async (
        request: HybrisResolveRecipesRequest,
        args: { storeId: string; userId: string; cartId: string },
    ) => {
        const requestQueryParams = {
            storeId: args.storeId,
        };

        const response = await getDirectHybrisAxiosClient(token).post<HybrisRecipeList>(
            `/users/${args.userId}/carts/${args.cartId}/recipes/products/resolve`,
            request,
            {
                params: requestQueryParams,
            },
        );
        return response.data;
    };

const getSubstitutes =
    (token?: string) => async (storeId: string, substituteIdentifier: string) => {
        const requestQueryParams = {
            storeId,
            product_substitute_id: substituteIdentifier,
        };

        const response = await getDirectHybrisAxiosClient(token).get<HybrisSubstituteResponse>(
            '/recipes/product/substitutes',
            {
                params: requestQueryParams,
            },
        );
        return response.data;
    };

export default {
    resolveRecipes,
    getSubstitutes,
};
